import script from "./GroupedAdvance.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupedAdvance.vue?vue&type=script&setup=true&lang=ts"

import "./GroupedAdvance.vue?vue&type=style&index=0&id=128ae0fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128ae0fe"]])

export default __exports__